module.exports = __webpack_public_path__ + "static/media/trial-icon.81343d10.svg";